import styled from "styled-components";
import React from "react";
import { PodSettings } from "../../assets/Podcast/PodSettings";
import { PodAnalytics } from "../../assets/Podcast/PodAnalytics";
import { PodRecipet } from "../../assets/Podcast/PodRecipet";
import { gql, useQuery } from "@apollo/client";
import { LoadingWLogo } from "../../components/LoadingWLogo";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { formatPrice, makePersian } from "../../components/helper/Price";
import { companies, months } from "./WorkPagePayroll";
import logo from "../../assets/Farazandishan-logo-1.png"
import { useState } from "react";
import { Printer } from "../../assets/Menu/Printer";
import { Translate } from "../../assets/Menu/Translate";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
const StyleCss = styled.div`
  .campaign {
    margin: 7.5px;
    padding: 5px 10px;
    border: 1px solid var(--n-grey-3);
    background-color: var(--n-grey-1);
    border-radius: 8px;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    text-decoration: none;
    color: var(--n-text-2);
    transition: all 0.15s ease-in-out;
    :hover {
      border: 1px solid var(--n-grey-7);
      color: var(--n-text-1);
    }
    &.header {
      border: none;
      background-color: transparent;
      margin: 7.5px 7.5px 0;
      font-weight: 500;
      .column {
        padding: 0.5rem 0.5rem 0;

      }
    }
    .column {
      padding: 0.5rem;
    }
  }
  &.rtl {
    .content {
      direction: rtl;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
    @media print {
      @page {
        size: 297mm 210mm;
        margin: 2rem;
      }
    }
  }
`;

const StylePayCss = styled.div`
  &.rtl {
    direction: rtl;
  }
  .top-part-main {
    display: flex;
    gap: 10px;
    align-items: center;
    .logo{
      flex-grow: 1;
      text-align: center;
      font-weight: 700;
      img {
        height: 50px;
      }
    }
  }
  .heading {
    margin: 1rem 0 0.5rem;
    padding: 0.7rem 1rem;
    border: 1px solid #000;
    background-color: #00000020;
    border-radius: 0rem;
    display: flex;
    /* justify-content: space-between; */
    flex-wrap: wrap;
    gap: 1%;
    .item {
      padding: 0.3rem 0;
      min-width: 19%;
      display: flex;
      gap: 0.5rem;
      .title-item {
        font-weight: 700;
      }
    }
  }
  .main-fish {
    display: grid;
    grid-template-columns: repeat(8, calc(100% / 8));
    border: 0.5px solid #000;
    
    .pos1 {
      grid-column: 5 span;
    }
    .pos2 {
      grid-column: 3 span;
    }
    .pos-col1 {
      grid-column: 3 span;
    }
    .pos-col2 {
      grid-column: 2 span;
    }
    .title {
      text-align: center;
      font-weight: 600;
      padding: 0.5rem 0;
      border: 0.5px solid #000;
      background-color: #00000020;
    }
    .discription-1 {
      padding: 0.5rem;
      grid-column: 1/4;
      border-right: 0.5px solid #000;
      border-left: 0.5px solid #000;
    }
    .value-1 {
      padding: 0.5rem;
      grid-column: 4/6;
      border-right: 0.5px solid #000;
      border-left: 0.5px solid #000;
    }
    .discription-2 {
      padding: 0.5rem;
      grid-column: 6/8;
      border-right: 0.5px solid #000;
      border-left: 0.5px solid #000;
    }
    .value-2 {
      padding: 0.5rem;
      grid-column: 8/9;
      border-right: 0.5px solid #000;
      border-left: 0.5px solid #000;
    }
    .sum {
      text-align: center;
      font-weight: 600;
      padding: 0.5rem 0;
      border: 0.5px solid #000;
      border-top: 1px solid #000;
    }
    .netsalary {
      text-align: center;
      font-weight: 600;
      padding: 0.5rem 0;
      border: 0.5px solid #000;
    }
  }
  .contract {
    padding: 0.7rem 1rem;
    display: flex;
    box-shadow: 0px 4px 8px -2px #00000040;
    border-radius: 4px;
    .expand {
      flex-grow: 1;
    }
    .date {
      width: 25%;
    }
    .more-info {
      color: blue;
      cursor: pointer;
    }
    &.header {
      font-weight: 700;
    }
  }
  .sums {
    margin: 1rem 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .item {
      display: flex;
      gap: 0.5rem;
      .title-item {
        font-weight: 700;
      }
    }
  }
`

const PayrollList_Query = gql`
  query HoghoghDetailQuery(
    $_id: ID!
  ){
    getListHoghoghDetail(
      _id: $_id
    ) {
      _id
      Hogog_CodPer
      Comp_Code
      MarHaz_Code
      MarHaz_Detail_Code
      Hogog_Sal
      Hogog_Mah
      Hogog_List
      Hogog_Rooz
      Hogog_Maza_Mab
      Hogog_Koso_Mab
      Hogog_Daryafti
      Hogog_Finish
      Hogog_Vazhiat
      Hogog_Morakhasi
      Hokme_No
      Hogog_Date_End
      ArzRate_code_Bimeh
      ArzRate_code_Malyat
      ArzRate_code_Hogog
      Hogog_Mab1_Flag
      Hogog_Mash_Bimeh
      Hogog_Mash_Malyat
      Sanad_shosan
      Sanad_shosan_Pardakht
      Hogog_AhdiExtra
      Hogog_SanavatExtra
      Hogog_Comment
      Hogog_Tamam_Saati
      Job_Name
      Job_Name_Latin
      Post_Name
      Post_Name_Latin
      details {
        _id
        MarHaz_Code
        MarHaz_Detail_Code
        Hogog_Sal
        Hogog_Mah
        Hogog_List
        Hogog_Radif
        Mazakoso_Type
        MazaKoso_Code
        Hogog_Mab
        Hogog_Megh
        MazaKoso {
          Mazakoso_Type
          MazaKoso_Code
          MazaKoso_Name
          MazaKoso_Name_Latin
          MazaKoso_Sum
        }
      }
    }
  }
`

function WorkPagePayrollSingle(props) {
  const [lan, setLan] = useState(false);
  const componentRef = useRef()
  const print = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "payroll",
  })
  const payroll = useQuery(PayrollList_Query, {
    variables: {
      _id: props.match.params.id
    },
    fetchPolicy: "network-only"
  });
  if(payroll.loading){
    return (
      <StyleCss className="main-box">
        <div className="title-bar">
            <div className="title">
              <div className="icon"><PodRecipet/></div>
              <div className="text">Payroll Detail</div>
            </div>
        </div>
        <div className="content">
          <LoadingWLogo/>
        </div>
      </StyleCss>
    )
  }
  const makeHeader = () => {
    let mainData = {};
    if(payroll.data && payroll.data.getListHoghoghDetail){
      mainData = payroll.data.getListHoghoghDetail;
    }
    let main = {
      Hogog_Sal: mainData.Hogog_Sal,
      Hogog_Mah: months[parseInt(mainData.Hogog_Mah)].en,
      name: props.userdata.FName,
      lastname: props.userdata.LName,
      code: props.userdata.Code,
      Per_CODBIM: props.userdata.Per_CODBIM,
      Hogog_CodPer: props.userdata.Hogog_CodPer,
      company: (companies[parseInt(mainData.MarHaz_Code)] ? companies[parseInt(mainData.MarHaz_Code)].en: "other"),
      Job_Name: mainData.Job_Name_Latin,
      Post_Name: mainData.Post_Name_Latin
    }
    if(lan){
      main = {
        Hogog_Sal: makePersian(mainData.Hogog_Sal, lan),
        Hogog_Mah: months[parseInt(mainData.Hogog_Mah)].fa,
        name: props.userdata.FName,
        lastname: props.userdata.LName,
        code: makePersian(props.userdata.Code, lan),
        Per_CODBIM: makePersian(props.userdata.Per_CODBIM, lan),
        Hogog_CodPer:  makePersian(props.userdata.Hogog_CodPer, lan),
        company: (companies[parseInt(mainData.MarHaz_Code)] ? companies[parseInt(mainData.MarHaz_Code)].fa: "other"),
        Job_Name: mainData.Job_Name,
        Post_Name: ""
      }
    }
    return (
      <>
      <div className="top-part-main">
        <div className="logo" style={{width: "25%"}}>
          <img src={logo} alt="logo"/>
        </div>
        <div className="logo" style={{width: "50%"}}>
          {main.Hogog_Sal} {main.Hogog_Mah}
        </div>
        <div className="logo" style={{width: "25%"}}></div>
      </div>
      <div className="heading">
        <div className="item">
          <div className="title-item">
            {dict["Name"][lan]}:
          </div>
          <div className="value-item">
            {main.name}
          </div>
        </div>
        <div className="item">
          <div className="title-item">
          {dict["Last Name"][lan]}:
          </div>
          <div className="value-item">
            {main.lastname}
          </div>
        </div>
        <div className="item">
          <div className="title-item">
          {dict["ID Code"][lan]}:
          </div>
          <div className="value-item">
            {main.code}
          </div>
        </div>
        <div className="item">
          <div className="title-item">
          {dict["SSO ID"][lan]}:
          </div>
          <div className="value-item">
            {main.Per_CODBIM}
          </div>
        </div>
        <div className="item">
          <div className="title-item">
          {dict["Staff ID"][lan]}:
          </div>
          <div className="value-item">
            {main.Hogog_CodPer}
          </div>
        </div>
        <div className="item">
          <div className="title-item">
          {dict["Cost Center"][lan]}:
          </div>
          <div className="value-item">
            {main.company}
          </div>
        </div>
        {
          (main.Job_Name && main.Job_Name.length > 2) ? (
            <div className="item">
              <div className="title-item">
              {dict["Job Name"][lan]}:
              </div>
              <div className="value-item">
                {main.Job_Name}
              </div>
            </div>
          ) : ""
        }
        {
          (main.Post_Name && main.Post_Name.length > 2) ? (
            <div className="item">
              <div className="title-item">
              {dict["Post Name"][lan]}:
              </div>
              <div className="value-item">
                {main.Post_Name}
              </div>
            </div>
          ) : ""
        }
        
      </div>
      </>
    )
  }
  
  const makeHoghoghsSalary = () => {
    let list = [];
    if(payroll.data && payroll.data.getListHoghoghDetail){
      list = payroll.data.getListHoghoghDetail.details;
    }
    let listNew = list.map((v, i) => {
      if(v.Mazakoso_Type === "0"){
        return (
          <>
            <div className="discription-1">{(lan) ? v.MazaKoso.MazaKoso_Name: v.MazaKoso.MazaKoso_Name_Latin} {(v.Hogog_Megh && v.Hogog_Megh !== "0" && (v.MazaKoso.MazaKoso_Code === "8" || v.MazaKoso.MazaKoso_Code === "301")) ? " / "+v.Hogog_Megh : ""}</div>
            <div className="value-1">{makePersian(formatPrice(v.Hogog_Mab), lan)}</div>
          </>
        )
      }
      return ;
    }).filter((v) => v);
    return listNew;
  }
  const makeHoghoghsDeduc = () => {
    let list = [];
    if(payroll.data && payroll.data.getListHoghoghDetail){
      list = payroll.data.getListHoghoghDetail.details;
    }
    return list.map((v, i) => {
      if(v.Mazakoso_Type !== "0"){
        return (
          <>
            <div className="discription-2">{lan ? v.MazaKoso.MazaKoso_Name : v.MazaKoso.MazaKoso_Name_Latin} {(v.Hogog_Megh && v.Hogog_Megh !== "0") ? " / "+v.Hogog_Megh : ""}</div>
            <div className="value-2">{makePersian(formatPrice(v.Hogog_Mab), lan)}</div>
          </>
        )
      }
      return;
    }).filter((v) => v);
  }
  const makeSums = () => {
    let list = [];
    if(payroll.data && payroll.data.getListHoghoghDetail){
      list = payroll.data.getListHoghoghDetail.details;
    }
    let sumAdd = 0;
    let sumSub = 0;
    let total = 0;
    for (let i = 0; i < list.length; i++) {
      const element = list[i];
      if(element.Mazakoso_Type === "0"){
        sumAdd+= parseInt(element.Hogog_Mab)
      } else {
        sumSub+= parseInt(element.Hogog_Mab)
      }
    }
    total = sumAdd - sumSub;
    return (
      <>
        <div className="sum pos-col1">
            {dict["Total Salary & Benefits"][lan]}
        </div>
        <div className="sum pos-col2">
          {makePersian(formatPrice(sumAdd), lan)}
        </div>
        <div className="sum pos-col2">
            {dict["Total Deductions"][lan]}
        </div>
        <div className="sum" style={{gridColumn: "1 span"}}>
          {makePersian(formatPrice(sumSub), lan)}
        </div>
        <div className="netsalary" style={{gridColumn: "3 span"}}>
            {dict["Net Salary"][lan]}
        </div>
        <div className="netsalary" style={{gridColumn: "2 span"}}>
          {makePersian(formatPrice(total), lan)}
        </div>
        <div className="netsalary " style={{gridColumn: "3 span"}}>
            {dict["Signature:"][lan]}
        </div>
      </>
    )
  }
  let generateSync = () => {
    let salary = makeHoghoghsSalary()
    let deduc = makeHoghoghsDeduc()
    let length = salary.length;
    if(length < deduc.length){
      length = deduc.length;
    }
    let returnHtm = [];
    for (let i = 0; i < length; i++) {
      if(salary[i]){
        returnHtm.push(salary[i]);
      } else {
        returnHtm.push(
          <>
            <div className="discription-1"></div>
            <div className="value-1"></div>
          </>
        );
      }
      if(deduc[i]){
        returnHtm.push(deduc[i]);
      } else {
        returnHtm.push(
          <>
            <div className="discription-2"></div>
            <div className="value-2"></div>
          </>
        );
      }
    }
    return returnHtm
  }
  return (
    <StyleCss className={"main-box" +((lan) ? " rtl" : "")}>
      <div className="title-bar">
          <div className="title">
            <div className="icon"><PodRecipet/></div>
            <div className="text">Payroll Detail</div>
          </div>
          <div className="expand"></div>
          <div className="action" onClick={() => setLan(!lan)}><Translate/></div>
          <div className="action" onClick={print}><Printer/></div>
      </div>
      <div className="content" ref={componentRef}>
        <StylePayCss className={(lan) ? " rtl" : ""}>
          {makeHeader()}
          <div className="main-fish">
            <div className="title pos1">
              {dict["Salary & Benefits"][lan]}
            </div>
            <div className="title pos2">
              {dict["Deductions"][lan]}
            </div>
            <div className="title pos-col1">
              {dict["Description"][lan]}
            </div>
            <div className="title pos-col2">
              {dict["Currency / IRR"][lan]}
            </div>
            <div className="title pos-col2">
              {dict["Deductions"][lan]}
            </div>
            <div className="title" style={{gridColumn: "1 span"}}>
              {dict["Currency / IRR"][lan]}
            </div>
            {generateSync()}
            {makeSums()}
          </div>
        </StylePayCss>
      </div>
    </StyleCss>
  )
}
export default WorkPagePayrollSingle;


const ShowPayroll = (props) => {
  
}


const dict = {
  "Name": {
    true: "نام",
    false: "Name"
  },
  "Last Name": {
    true: "نام خانوادگی",
    false: "Last Name"
  },
  "ID Code": {
    true: "کد ملی",
    false: "ID Code"
  },
  "SSO ID": {
    true: "کد بیمه",
    false: "SSO ID"
  },
  "Staff ID": {
    true: "کد پرسنلی",
    false: "Staff ID"
  },
  "Cost Center": {
    true: "شرکت",
    false: "Cost Center"
  },
  "Job Name": {
    true: "شغل",
    false: "Job Name"
  },
  "Post Name": {
    true: "موقعیت شغلی",
    false: "Post Name"
  },
  "Salary & Benefits": {
    true: "حقوق و مزایا",
    false: "Salary & Benefits"
  },
  "Deductions": {
    true: "کسورات",
    false: "Deductions"
  },
  "Description": {
    true: "توضیحات",
    false: "Description"
  },
  "Currency / IRR": {
    true: "مقدار / ریال",
    false: "Currency / IRR"
  },
  "Total Salary & Benefits": {
    true: "مجموع حقوق و مزایا",
    false: "Total Salary & Benefits"
  },
  "Total Deductions": {
    true: "مجموع کسورات",
    false: "Total Deductions"
  },
  "Net Salary": {
    true: "حقوق خالص",
    false: "Net Salary"
  },
  "Signature:": {
    true: "امضا:",
    false: "Signature:"
  }
}